export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            欢迎投稿、咨询或提出建议，小草影院团队期待与您交流
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-xl p-8 md:p-10 border border-background-200/70">
            <div className="flex flex-col sm:flex-row items-start gap-6">
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-send-line text-2xl text-primary-600"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground-900 mb-2 font-heading">
                  投稿与合作咨询
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  如果您有电影推荐、影片资源或商务合作需求，欢迎通过以下方式与我们取得联系。我们会在24小时内回复您的消息。
                </p>
                <div className="flex flex-col gap-3">
                  <a
                    href="mailto:contact@xiaocaocinema.com"
                    className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-mail-line"></i>
                    contact@xiaocaocinema.com
                  </a>
                  <div className="flex items-center gap-2 text-sm text-foreground-600">
                    <i className="ri-time-line"></i>
                    工作日 9:00 - 18:00
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}